import { Box, Typography } from "@mui/material";
import { PrimaryTooltip } from "../../../Components/StyledComponent";
import { ArrowUp, ArrowDown, ArrowNoChange } from "../../../Components/Icons/ArrowIcon";

/**
 * @param {number} count
 * @param {number} percentage
 * @param {boolean} positiveWhenIncrease
 */
const ChangeIndicator = ({ count = 0, percentage = 0, positiveWhenIncrease = true }) => {
  if (count === 0) {
    return (
      <PrimaryTooltip title="No change vs. Yesterday">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            color: "#686868",
            "&:hover": { color: "#494949" },
            cursor: "default",
          }}
        >
          <ArrowNoChange color="#686868" />
          <Typography variant="fw500s12c000" sx={{ color: "inherit", lineHeight: "18px" }}>
            0%
          </Typography>
        </Box>
      </PrimaryTooltip>
    );
  }

  let color;
  let hoverColor;
  let ArrowIcon;
  let tooltipText;

  if (count > 0) {
    ArrowIcon = ArrowUp;
    const isGood = positiveWhenIncrease;
    color = isGood ? "#008A15" : "#B50500";
    hoverColor = isGood ? "#04580F" : "#930500";
    tooltipText = `+${count} vs. Yesterday`;
  } else {
    ArrowIcon = ArrowDown;
    const isGood = !positiveWhenIncrease;
    color = isGood ? "#008A15" : "#B50500";
    hoverColor = isGood ? "#04580F" : "#930500";
    tooltipText = `${count} vs. Yesterday`;
  }

  const formatPercentage = (pct) => {
    if (!Number.isFinite(pct)) return "0";

    const rounded = Math.abs(pct);

    if (Number.isInteger(rounded)) {
      return rounded.toString();
    }

    // check if second decimal digit is zero
    const twoDec = rounded.toFixed(2);
    if (twoDec.endsWith("0")) {
      return rounded.toFixed(1);
    }

    return twoDec;
  };

  const displayPct = formatPercentage(percentage);

  return (
    <PrimaryTooltip title={tooltipText}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          color,
          "&:hover": { color: hoverColor },
          cursor: "default",
        }}
      >
        <ArrowIcon color={color} />
        <Typography variant="fw500s12c000" sx={{ color: "inherit", lineHeight: "18px" }}>
          {displayPct}%
        </Typography>
      </Box>
    </PrimaryTooltip>
  );
};

export default ChangeIndicator;
